const actions = {
	REFER_A_FRIEND_DIALOG_TOGGLE: 'REFER_A_FRIEND_DIALOG_TOGGLE',
	toggleDialog: (isOpen) => ({
		type: actions.REFER_A_FRIEND_DIALOG_TOGGLE,
		isOpen,
	}),
};

export default actions;
